import { NavLink } from "react-router-dom";
import { navigationLinks } from "../../utils/constants";
import ThemeSwitchComponent from "./ThemeSwitch/ThemeSwitchComponent";
import { navLinkStyle } from "../../utils/styles/navigationStyles";
import { useContext } from "react";
import { ThemeContext } from "../../App";
import { ToolTipComponent } from "../ToolTipComponent/toolTipComponent";
import { ScrollIndicatorComponent } from "./ScrollIndicatorComponent";

export default function NavigationBarComponent(){
    const [theme,setTheme] = useContext(ThemeContext);
    return (
        <div style = {{width: '100%', textAlign: 'center', position: 'fixed', height: '60px', top:0, backgroundColor: theme.primary,zIndex:10000}}>
        <div style = {{
            padding: 10,
            display: 'flex',
            justifyContent: 'center'
            }}>
                
            {navigationLinks.map((link) => {
                return <NavLink key = {link.name} style = {(isActive) => navLinkStyle(theme,isActive)} to = {link.path}>{link.name}</NavLink>
            })}
            <ToolTipComponent text = "Current theme"><ThemeSwitchComponent/></ToolTipComponent>
        </div>
        <ScrollIndicatorComponent />
        </div>
    )
}